import { JoistPlacement } from "building-types/floors/floorComponentsTypes";
import type { LumberPiecesByProfile } from "./lumberTypes";

/**
 * Floor framing component types
 */
export enum FloorFramingComponentType {
  FLOOR_JOIST = "FLOOR_JOIST", // Main floor joists
  FLOOR_BEAM = "FLOOR_BEAM", // Primary floor support beams
  RIM_JOIST = "RIM_JOIST", // Perimeter rim joists
  HEADER = "HEADER", // Headers around openings
  TRIMMER = "TRIMMER", // Trimmers around openings
  TAIL_JOIST = "TAIL_JOIST", // Tail joists from headers to supporting members
  NOGGIN = "NOGGIN", // Blocking between joists
}

export interface FloorFramingComponentBase<T extends FloorFramingComponentType> {
  readonly type: T;
}

export interface FloorFramingComponent extends FloorFramingComponentBase<FloorFramingComponentType> {
  readonly lumber: LumberPiecesByProfile;
}

const floorFramingComponentTypeByJoistPlacement: Record<JoistPlacement, FloorFramingComponentType> = {
  [JoistPlacement.RIM]: FloorFramingComponentType.RIM_JOIST,
  [JoistPlacement.FLOOR]: FloorFramingComponentType.FLOOR_JOIST,
  [JoistPlacement.NOGGIN]: FloorFramingComponentType.NOGGIN,
};

function isJoistPlacement(placement: string): placement is JoistPlacement {
  return placement === JoistPlacement.RIM || placement === JoistPlacement.FLOOR || placement === JoistPlacement.NOGGIN;
}

export function floorFramingComponentTypeFromJoistPlacement(placement: JoistPlacement): FloorFramingComponentType;
export function floorFramingComponentTypeFromJoistPlacement(placement: string): FloorFramingComponentType | undefined;
export function floorFramingComponentTypeFromJoistPlacement(placement: string): FloorFramingComponentType | undefined {
  if (!isJoistPlacement(placement)) {
    return undefined;
  }
  return floorFramingComponentTypeByJoistPlacement[placement];
}
